__turbopack_context__.v({
  "ConfirmButton": "VerificationCodeModal-module-scss-module__M8-Bpq__ConfirmButton",
  "Description": "VerificationCodeModal-module-scss-module__M8-Bpq__Description",
  "Modal": "VerificationCodeModal-module-scss-module__M8-Bpq__Modal",
  "RefetchLink": "VerificationCodeModal-module-scss-module__M8-Bpq__RefetchLink",
  "ResendButton": "VerificationCodeModal-module-scss-module__M8-Bpq__ResendButton",
  "Title": "VerificationCodeModal-module-scss-module__M8-Bpq__Title",
});
